<div
  class="member-picture"
  [ngStyle]="{ width: size + 'px', height: size + 'px' }"
  [ngClass]="{ square: square }"
  >
  @if (member.image && !highRes) {
    <img
      [src]="member.image.thumbnailUrl || member.image.imageUrl"
      alt="Profielfoto van {{member.firstName}}"
      />
  }
  @if (member.image && highRes) {
    <img
      [src]="member.image.imageUrl || member.image.thumbnailUrl"
      alt="Profielfoto van {{member.firstName}}"
      />
  }
  @if (!member.image) {
    <img src="/assets/images/no_photo.png"
      alt="{{member.firstName}} heeft geen profielfoto"
      />
  }
</div>
